import { CircularProgress, IconTypesKeys, Tree, TreeId } from "@evergis/ui";
import React, { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAppConfig } from "../../../../ducks/appConfig";
import { ProxyLayersList } from "../../DialogComponents/ProxyLayers/styled";
import {
  AttributesBlockContainer as ProxyLayersContainer,
  RestrictedWidthContainer,
} from "../../DialogComponents/styled";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { ProxyLayersHeader } from "./styled";

export const DEFAULT_MAX_LAYERS_COUNT = 5;

export const ProxyServiceLayers: FC = () => {
  const { t } = useTranslation("dialogs");
  const { treeData, layersLoading, layers, setLayers } = useAddProxyServiceContext();
  const [expanded, setExpanded] = useState<TreeId[]>();
  const appConfig = useSelector(getAppConfig);
  const allowedWMSLayers = appConfig?.settings?.allowedWMSLayers;

  const allowedLayersCount = typeof allowedWMSLayers === "number" ? allowedWMSLayers : DEFAULT_MAX_LAYERS_COUNT;
  const headerConfiguration = useMemo(
    () => ({
      icon: "layers" as IconTypesKeys,
      label: t("addProxyService.layers"),
      description: t("addProxyService.chooseProxyLayers").replace("{wmsLayersCount}", allowedLayersCount.toString()),
    }),
    [t, allowedLayersCount],
  );

  const onSelect = useCallback(
    (selectedLayers: TreeId[]) => {
      setLayers((selectedLayers as string[]).slice(0, allowedLayersCount));
    },
    [setLayers, allowedLayersCount],
  );

  return (
    <ProxyLayersContainer>
      <ProxyLayersHeader showTitle headerConfiguration={headerConfiguration} />
      <RestrictedWidthContainer>
        <ProxyLayersList>
          {layersLoading && <CircularProgress />}
          {!layersLoading && (
            <Tree
              data={treeData}
              selectable
              selected={layers}
              expanded={expanded}
              allExpanded
              setExpanded={setExpanded}
              setSelected={onSelect}
              childIcon={null}
            />
          )}
        </ProxyLayersList>
      </RestrictedWidthContainer>
    </ProxyLayersContainer>
  );
};
